<header>
    <nav class="mx-auto flex container items-center justify-between p-4" aria-label="Global">
        <div class="flex flex-1">
            <div class="hidden lg:flex lg:gap-x-12">
                <white-label-header-navigation></white-label-header-navigation>
            </div>
            <div class="flex lg:hidden">
                <white-label-mobile-menu></white-label-mobile-menu>
            </div>
        </div>
        <a [routerLink]="'/'" class="-m-1.5 p-1.5">
            <span class="sr-only">{{whiteLabel?.name}}</span>
            <img class="h-20 relative w-auto" [src]="whiteLabel?.logoUrl" [alt]="whiteLabel?.name">
        </a>
        <div class="flex flex-1 justify-end">
            <white-label-header-actions></white-label-header-actions>
        </div>
    </nav>
</header>
